import React from 'react';
import styles from "./scss/set-password.module.scss";
//import logo from "../../../src/logo.svg";
import logofav from '../../../src/logo.svg';
import { URButton } from '../../shared/widgets/button';
//import { URInput } from '../../shared/widgets/input';
import { Link } from 'react-router-dom';
import { Input, Tooltip } from 'antd';
function SetNewPassword() {
  return (
    <>
      <div className={styles.loginPage}>
        <div className={styles.headerRow}>
          <div className={styles.logoSec}>
            <img src={logofav} alt="Header Logo" />
          </div>
          <div className={styles.closeIcon}>
            <span className="icon_close_line"></span>
          </div>
        </div>
        <div className={styles.signInSec}>
          {/* <div className={styles.loadingSec}>
          <object data={loaderblue} type="image/svg+xml">Loading...</object>
        </div> */}
          <h5 className={styles.loginText}>Reset Password</h5>
          <p className={styles.forgotContent}>Enter the new password</p>
          <div className={styles.forgetPage}>
            {/* <div className={styles.formLabel}>
                    <label className={styles.inputLabel}>New Password</label>
                    <URInput placeHolder="" className="resetNewPassword" />
                    <p className={styles.errorMsgs}>Required data missing.</p>
                </div> */}
            <div className={styles.formLabel}>
              <label className={styles.inputLabel}>Password</label>
              {/* <URInput placeHolder="" className="passwordBox" />
                    <span className={`icon_password_show_line ${styles.showPass}`}></span> */}
              {/* <img src={eye} alt="" className={styles.showPass} /> */}
              <Input.Password placeholder="" className="resetNewPassword"
                iconRender={visible => (visible ?
                  <Tooltip placement="top" title="Hide Password" overlayClassName='cusTooltip'>
                    <span className="icon_Viewpassword shpass"></span></Tooltip> :
                  <Tooltip placement="top" title="Show Password" overlayClassName='cusTooltip'>
                    <span className="icon_Fillpassword shpass"></span></Tooltip>)}/>
              <p className={styles.errorMsgs}>Required data missing.</p>
            </div>
            <div className={styles.validation}>
              <h4>Password Strength : <span className={styles.strengthText}>Weak</span></h4>
              <div className={`${styles.lineValidate} ${styles.extreme}`}>
                <span className={styles.validatorLine}></span>
                <span className={styles.validatorLine}></span>
                <span className={styles.validatorLine}></span>
                <span className={styles.validatorLine}></span>
              </div>
              <div className={styles.validateText}>
                <div className={`${styles.validator} ${styles.success}`}>
                  <p><span className="icon_Bulletsquare"></span><span>Minimum 8 characters</span></p>
                </div>
                <div className={styles.validator}>
                  <p><span className="icon_Bulletsquare"></span><span>At least 1 uppercase letter</span></p>
                </div>
                <div className={styles.validator}>
                  <p><span className="icon_Bulletsquare"></span><span>At least 1 number</span></p>
                </div>
              </div>
            </div>
            <URButton className={'resetLink'} name={'Update Password'} type={'primary'} />
          </div>
          <Link to="" className={styles.backLink}><span className="icon_outlineleftarrow"></span>
            <span className={styles.backText}>Back to login</span></Link>
        </div>
      </div>
    </>
  );
}

export default SetNewPassword;